<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss">
body {
  padding: 0px;
  margin: 0px;
}

/*全局滚动条样式*/
::-webkit-scrollbar {
  width: 0px;
  height: 14px;
}

::-webkit-scrollbar-thumb {
  /* background-color: #01c8dc;
border-radius: 3px; */
  background-color: #b6b6b6;
}

/*提示弹出框样式*/
.el-message {
  background: #161d37 !important;
  border-color: #161d37 !important;
  font-size: 18px;
}

.el-message .el-message__content {
  font-size: 15px;
}

// 删除或退出提示
.el-message-box {
  min-width: 350px !important;
  max-width: 800px !important;
  width: auto !important;
  background: #202740 !important;
  border-color: #202740 !important;
}

.el-message-box .el-message-box__header {
  width: 100% !important;
  padding: 10px 0px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(
    to bottom,
    rgba(30, 37, 62, 1),
    rgba(40, 47, 72, 1)
  );
  color: #fff;
}

.el-message-box .el-message-box__title {
  color: #fff;
  font-size: 15px;
  display: flex;
  align-items: center;
}
.el-message-box .el-message-box__title::before {
  content: "";
  background: url(./assets/img/icon/headerIcon.svg) 0px 0px no-repeat;
  background-size: 100% 100%;
  width: 18px;
  height: 18px;
  display: inline-block;
  margin: 0px 10px;
}

.el-message-box .el-message-box__headerbtn {
  top: 10px;
  right: 10px;
  font-size: 20px;
  font-weight: 700;
}
.el-message-box .el-message-box__close.el-icon-close {
  color: #ef036b;
}

// 中间内容
.el-message-box .el-message-box__content {
  min-height: 50px;
  max-height: 400px;
  overflow: auto;
  justify-content: center;
  align-items: center;
  color: #5a6699;
  font-size: 15px;
}

// 按钮
.el-message-box .el-message-box__btns {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
}

.el-message-box .el-message-box__btns .el-button {
  background: #464d66;
  border-color: transparent;
  color: #fff;
}

.el-message-box .el-message-box__btns .el-button:hover {
  background: #22d8de;
}

// 调换一下确定和取消位置
.el-message-box .el-message-box__btns .el-button:last-child {
  order: -1;
  margin-right: 10px;
  margin-left: -10px;
}

.v-modal {
  opacity: 0.8 !important;
}
</style>
